<script setup>
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-dialog 
	v-model="save_d_flg"
	width="800px"
>
<v-card
	width="800px"
>
	<v-toolbar
		flat
		color="#E11D31"
		dark
		height="50px"
	>
		<v-spacer />
		<v-icon
			@click="save_d_flg=false"
		>
			mdi-close
		</v-icon>
	</v-toolbar>
	<v-card-text class="mt-5">
		<v-row>
			<v-col cols="2">
				<span class="input-title">名前をつけて保存</span>
			</v-col>
			<v-col>
				<v-text-field
					v-model="list_name"
					clearable
					hide-details="auto"
					dense
					placeholder="メディアリストの名前を入力してください。"
					outlined
				></v-text-field>
			</v-col>
		</v-row>
	</v-card-text>
	<v-card-actions>
		<v-spacer />
		<v-btn
			color="#E11D31"
			dark
			@click="save"
		>
			<v-icon>mdi-content-save</v-icon>
			保存
		</v-btn>
	</v-card-actions>
</v-card>
</v-dialog>
</template>
<script>
export default {
	data : function(){
		return {
			save_d_flg : false,
			list_name  : "",
		};
	},
	methods : {
		open : function(){
			this.save_d_flg=true;
		},
		save : function(){
			var params = new URLSearchParams();
			params.append('label', this.list_name);
			axios.post("/api/media/newlist",params)
			.then(response => {
                this.$store.commit("mediacand/set_candlist",response.data);
				this.save_d_flg=false;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });

		},
	},
}
</script>
